import React, { useEffect, useState, useRef } from "react";
import {
	TextField,
	Button,
	Box,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableFooter,
	TableHead,
	TableRow,
	Paper,
} from "@mui/material";
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';

import "../../../css/empresa_uno/ventas.css";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { ModalNuevoCliente } from "../ModalNuevoCliente";
import { toast } from "react-toastify";
import { ModalSearchClienteVC } from "../ModalSearchClienteVC";
import { ApiService } from "../../ApiService";
import { GeneratePdfCotizacion } from "./GeneratePdfCotizacion";
import TableMobile from "../../empresa/TableMobile";
import { ModalSearchProductVC } from "../ModalSearchProductVC";
import CallApi from "../../../data/CallApi";
import ButtonLoader from "../../global/ButtonLoader";

export const Vcotizacion = ({ selectedSucursal, loadImageS, convertPrice = (() => { }), currency }) => {
	const [clienteSeleccionado, setClienteSeleccionado] = useState(null);
	const [facturadoMonto, setFacturadoMonto] = useState(1);
	const [delivery, setDelivery] = useState(0);
	const [garantia, setGarantia] = useState(null);
	const [stateFetch, setStateFetch] = useState(false);
	// Aquí guardamos los productos que se van agregando a la tabla
	const [addedProducts, setAddedProducts] = useState([]);
	const [pdfModalVisible, setPdfModalVisible] = useState(false);
	const [currentSize, setCurrentSize] = useState(window.innerWidth);

	const onPdfModalClose = () => {
		setPdfModalVisible(false);
		setPdfApiResponse({});
	};
	const [pdfApiResponse, setPdfApiResponse] = useState({});
	const states = ["off", "all", "on"];
	const [index_toggle, setIndex] = useState(0);
	const handleChange = () => {
		setIndex((prevIndex) => (prevIndex + 1) % states.length);
	};

	//modal para nuevo cliente
	const [isModalOpenCliente, setIsModalOpenCliente] = useState(false);
	const handleOpenModalCliente = () => {
		setIsModalOpenCliente(true);
	};
	const handleCloseModalCliente = () => {
		setIsModalOpenCliente(false);
	};
	//modal para escoger cliente
	const [isModalOpenEscoger, setIsModalOpenEscoger] = useState(false); // Controla la visibilidad del modal

	// Maneja la selección del cliente en el modal
	const handleUserSelect = (cliente) => {
		if (addedProducts.length > 0) {
			setAddedProducts((current_list) => {
				return current_list.map((obj) => {
					obj.precio = cliente.user_disc != null ? obj.wholesalerPrice : obj.retailPrice;
					return obj;
				});
			});
		}

		setClienteSeleccionado(cliente);
		handleCloseModalCliente();
	};

	const handleFacturadoMontoChange = (event) => {
		const value = event.target.value;
		setFacturadoMonto(value > 99 ? 100 : value);
	};

	const handleIncreaseQuantity = (index) => {
		setAddedProducts((prev) => {
			const updated = [...prev];
			let newVal = updated[index].cantidad + 1;
			// No exceder stock
			if (newVal > updated[index].stock) {
				newVal = updated[index].stock;
			}
			updated[index].cantidad = newVal;
			return updated;
		});
	};
	const handleDecreaseQuantity = (index) => {
		setAddedProducts((prev) => {
			const updated = [...prev];
			let newVal = updated[index].cantidad - 1;
			// No bajar de 1
			if (newVal < 1) {
				newVal = 1;
			}
			updated[index].cantidad = newVal;
			return updated;
		});
	};
	// Cambia la cantidad en el TextField (por si el usuario escribe manualmente)
	const handleChangeCantidad = (index, value) => {
		setAddedProducts((prev) => {
			const updated = [...prev];
			let newVal = Number(value);
			if (newVal > updated[index].stock) {
				newVal = updated[index].stock;
			}
			if (newVal < 1) {
				newVal = 1;
			}
			updated[index].cantidad = newVal;
			return updated;
		});
	};
	const handleChangeDescuento = (index, value) => {
		if (clienteSeleccionado && clienteSeleccionado.user_disc) return;

		setAddedProducts((prev) => {
			const updated = [...prev];
			updated[index].descuento = value;
			return updated;
		});
	};
	// Elimina un producto de la tabla
	const handleRemoveProduct = (index) => {
		setCurrentDetail(null);

		setAddedProducts((prev) => {
			const updated = [...prev];
			updated.splice(index, 1);
			return updated;
		});
	};
	// Al cambiar el delivery, aseguramos que no sea negativo
	const handleDeliveryChange = (e) => {
		let val = Number(e.target.value);
		if (val < 0) {
			val = 0;
		}
		setDelivery(val);
	};
	const totalDescuento =
		(clienteSeleccionado && clienteSeleccionado.user_disc > 0) || addedProducts
			? addedProducts
				.reduce((acc, item) => {
					const discount =
						clienteSeleccionado.user_disc > 0
							? parseFloat(item.precio) * (clienteSeleccionado.user_disc / 100)
							: item.descuento || 0;
					return acc + discount * item.cantidad;
				}, 0)
				.toFixed(2)
			: 0;
	const current_date = () => {
		const newDate = new Date();
		const year = newDate.getFullYear();
		const mes = newDate.getMonth() + 1;
		const dia = newDate.getDate();

		return `${year}-${mes < 10 ? "0" + mes : mes}-${dia < 10 ? "0" + dia : dia}`;
	};

	async function insertNewCotizacion() {
		if (addedProducts.length === 0) return toast.error("No es posible generar sin ventas");
		if (!clienteSeleccionado.auth) return toast.error("No es posible generar sin un cliente seleccionado");

		try {
			setStateFetch(true);

			const array_body = {
				num_billed: index_toggle !== 0 ? facturadoMonto || 0 : 0,
				billed_state: index_toggle === 1 ? 2 : index_toggle !== 0 ? 1 : 0,
				persona: clienteSeleccionado.auth,
				validity: garantia || current_date(),
				detail: addedProducts.map((obj) => ({
					product: obj.id,
					price: parseFloat(obj.precio).toFixed(2),
					discount: clienteSeleccionado.user_disc > 0 ? 0 : obj.descuento || 0,
					quantity_product: obj.cantidad || 1,
				})),
			};

			if (delivery && delivery > 0) array_body.delivery = delivery;

			const fetch_request = await CallApi({
				url: `api/company/quotation/insert?key_branch=${selectedSucursal}`,
				method: "POST",
				body: array_body,
				showMessage: true
			});

			if (fetch_request?.code === 200) {
				let keyQuotation = fetch_request.key_quotation;

				const pdfData = await CallApi({
					url: `api/company/quotation/find/${keyQuotation}?key_branch=${selectedSucursal}`
				});

				setPdfApiResponse(pdfData);
				setPdfModalVisible(true);
			}
		} catch (error) {
			console.error("Error:", error);
		} finally {
			setStateFetch(false);
		}
	}

	const calcular_total = (producto) => {
		const precioFacturado =
			parseFloat(producto.precio) * ((index_toggle != 2 ? 0 : facturadoMonto) / 100);
		const precioDescuento =
			clienteSeleccionado && clienteSeleccionado.user_disc == null
				? parseFloat(producto.descuento || 0)
				: parseFloat(producto.precio) * (Number(clienteSeleccionado.user_disc) / 100);
		const totalProducto = parseFloat(
			(parseFloat(producto.precio) + precioFacturado - precioDescuento) *
			Number(producto.cantidad)
		).toFixed(2);

		return totalProducto;
	}

	const returnTotalOperation = (decision = false) => {
		const result = decision ?
			(
				(addedProducts &&
					addedProducts.reduce((acc, item) => {
						const newPrice =
							(parseFloat(item.precio) +
								(facturadoMonto / 100) * parseFloat(item.precio)) *
							item.cantidad;
						return acc + parseFloat(newPrice);
					}, 0)) +
				delivery -
				totalDescuento
			).toFixed(2)
			: (
				(addedProducts &&
					addedProducts.reduce(
						(acc, item) => acc + parseFloat(item.precio) * item.cantidad,
						0
					)) +
				delivery -
				totalDescuento
			).toFixed(2);
		return result;
	}

	const refModalMobile = useRef(null);
	const [currentDetail, setCurrentDetail] = useState(null);

	const buttonDetailSaleMobile = (objs, index) => {
		return (
			<>
				<button className="default-buttons show-details" id={`saleMobile_${index}`} name="show-modal-mobile" style={{ position: 'relative' }}
					onClick={(event) => {
						event.stopPropagation();
						setCurrentDetail(index)
					}}
				>
					<MoreHorizIcon style={{ fontSize: '30px' }} color="var(--theme-company)" />
				</button>
				{
					currentDetail == index && (
						<div className="detail-mobile-products shadow-lvl6"
							style={{
								display: 'flex',
								bottom: '40%',
								right: 35
							}}
							ref={refModalMobile}
						>
							<h3 className='' style={{ textAlign: 'left', fontSize: '1.2rem', fontWeight: 550, color: 'var(--theme-company)' }}>{objs?.nombre} &nbsp;
								<Button
									variant="contained"
									size="small"
									onClick={() => handleRemoveProduct(index)}
									sx={{
										"backgroundColor": "red",
										"color": "#fff",
										"padding": 0,
										"width": "30px",
										"minWidth": "30px",
										"height": "30px",
										"&:hover": {
											backgroundColor: "#c60000",
										},
									}}>
									<FontAwesomeIcon
										icon={faTrash}
										style={{ color: "#fff", fontSize: "15px" }}
									/>
								</Button>
							</h3>

							<div>
								<h4>CODIGO</h4>
								<span>{objs?.codigo}</span>
							</div>

							<div>
								<h4>PRECIO U.</h4>
								<span>{objs?.precio}</span>
							</div>

							<div style={{ display: 'flex', alignItems: 'center', gap: '5px', justifyContent: 'flex-start' }}>
								<h4>DESCUENTO</h4>
								{
									clienteSeleccionado?.user_disc > 0 ? (
										<span>{clienteSeleccionado?.user_disc + "%"}</span>
									) : (
										<strong>
											<input type="number"
												style={{ textAlign: 'center', width: '100px', borderRadius: '10px', backgroundColor: '#F2F2F2', border: 'none', fontSize: '16px', padding: '8px 5px' }}
												value={objs?.descuento}
												onChange={(event) => handleChangeDescuento(index, event.target.value)}
												placeholder="0"
											/> BS.
										</strong>
									)
								}
							</div>

							<div>
								<h4>CANTIDAD</h4>
								<div style={{ display: 'flex', alignItems: 'center', gap: '10px', justifyContent: 'flex-start' }}>
									<button onClick={() => handleDecreaseQuantity(index)} className="default-buttons" style={{ height: 'min-content', backgroundColor: '#1b38b9', color: 'var(--theme-main)', fontSize: '40px', width: '30px', height: '30px' }}>-</button>
									<input type="number"
										style={{ textAlign: 'center', width: '100px', borderRadius: '10px', backgroundColor: '#F2F2F2', border: 'none', fontSize: '16px', padding: '8px 5px' }}
										value={objs?.cantidad}
										onChange={(event) => handleChangeCantidad(index, event.target.value)}
										placeholder="0"
									/>
									<button onClick={() => handleIncreaseQuantity(index)} className="default-buttons" style={{ height: 'min-content', backgroundColor: '#1b38b9', color: 'var(--theme-main)', fontSize: '40px', width: '30px', height: '30px' }}>+</button>
								</div>
							</div>
						</div>
					)
				}
			</>
		);
	}

	useEffect(() => {
		const handleResize = () => setCurrentSize(window.innerWidth);

		const mainContent = document.getElementById("main-page");
		function closeMiniModal(event) {
			if (refModalMobile.current && !refModalMobile.current.contains(event.target) && window.innerWidth < 500) setCurrentDetail(null);
		}

		window.addEventListener('resize', handleResize);
		if (mainContent) mainContent.addEventListener("click", closeMiniModal)

		return () => {
			window.removeEventListener('resize', handleResize);
			if (mainContent) mainContent.removeEventListener("click", closeMiniModal);
		};
	}, []);

	return (
		<div className="container-vc">
			{/* Encabezado (codigo CSS pura mrd, mejor ni lo toco)*/}
			<div className="head-vc">
				<div>
					<h2 style={{ color: 'var(--theme-company)' }}>Cotización</h2>
				</div>

				<ModalSearchProductVC
					addedProducts={addedProducts}
					setAddProduct={setAddedProducts}
					clientSelected={clienteSeleccionado}
				/>

				<span>{localStorage.getItem("name") || "(Yo)"}</span>
			</div>

			{/* Formulario superior */}
			<div className="body-content">
				{/* Parte izquierda */}
				<div style={{ flex: "0 1 350px" }}>
					<div>
						<span className="label-form-view">Buscar Cliente</span>
						<button onClick={handleOpenModalCliente} className="add-cliente-label">
							{" "}
							<span>+</span> Agregar
						</button>
					</div>
					<div>
						<TextField
							size="small"
							fullWidth
							value={
								clienteSeleccionado
									? `${clienteSeleccionado.fullName} - ${clienteSeleccionado.phone}`
									: ""
							}
							placeholder="Seleccione un cliente"
							onClick={() => setIsModalOpenEscoger(true)}
							slotProps={{
								htmlInput: {
									readOnly: true,
								},
							}}
						/>
					</div>

					{/* Modal de búsqueda de clientes */}
					<ModalSearchClienteVC
						isOpen={isModalOpenEscoger}
						onClose={setIsModalOpenEscoger}
						onUserSelect={handleUserSelect}
						searchResults={selectedSucursal}
						selectedSucursal={selectedSucursal}
					/>
				</div>

				{/* Parte del medio */}
				<div
					style={{
						display: "flex",
						flexFlow: "column nowrap",
						alignItems: "center",
						justifyContent: "space-between",
						flex: "0 1 150px",
						marginTop: "-10px",
					}}>
					<div style={{ display: "flex", flexFlow: "row nowrap", alignItems: "center" }}>
						<Box
							sx={{
								display: "flex",
								alignItems: "center",
								justifyContent: "space-between",
								mb: 2,
							}}>
							<Box
								sx={{
									display: "flex",
									alignItems: "center",
									gap: 1,
									marginTop: "3px",
									marginBottom: "2px",
								}}>
								<label className="label-form-view">Facturado</label>

								<div className="toggle-wrapper">
									<div className={`toggle-container ${states[index_toggle]}`} onClick={handleChange}>
										<div className="toggle-ball"></div>
									</div>
									<div className="toggle-label">
										{states[index_toggle] === "on"
											? "On"
											: states[index_toggle] === "off"
												? "Off"
												: "All"}
									</div>
								</div>
							</Box>
						</Box>
					</div>

					<TextField
						type="number"
						variant="outlined"
						size="small"
						fullWidth
						value={facturadoMonto}
						onChange={handleFacturadoMontoChange}
						disabled={index_toggle == 0}
						sx={{ mb: 2 }}
					/>
				</div>

				<div style={{ flex: "0 1 150px" }}>
					<span className="label-form-view">Delivery</span>
					<TextField
						type="number"
						variant="outlined"
						size="small"
						fullWidth
						placeholder="0"
						// value={delivery}
						onChange={handleDeliveryChange}
						sx={{ mb: 2 }}
					/>
				</div>

				<div style={{ flex: "0 1 200px" }}>
					<span className="label-form-view">Vigencia</span>
					<TextField
						value={garantia || current_date()}
						onChange={(event) => {
							setGarantia(event.target.value);
						}}
						type="date"
						variant="outlined"
						size="small"
						fullWidth
					/>
				</div>

				<ButtonLoader state_progress={stateFetch} custom_styles={{
					padding: "5px 10px",
					borderRadius: "10px",
					backgroundColor: "rgb(45, 127, 10)",
					color: "#fff",
					borderColor: "rgba(0,0,0,0.3)",
					margin: "auto",
					flexGrow: "1",
					flexShrink: "1",
				}} onClick={insertNewCotizacion}>
					<b>Cotizar</b>
				</ButtonLoader>
			</div>

			{/* Tabla de productos agregados */}

			{
				currentSize > 480 ? (
					<div className="table-view-pc">
						<TableContainer component={Paper} sx={{ mt: 4 }} style={{ marginBottom: "20px" }}>
							<Table>
								{/* Encabezado */}
								<TableHead>
									<TableRow>
										<TableCell
											align="center"
											sx={{ fontWeight: "bold", backgroundColor: 'var(--theme-company)', color: "#fff" }}>
											Código
										</TableCell>
										<TableCell
											align="center"
											sx={{ fontWeight: "bold", backgroundColor: 'var(--theme-company)', color: "#fff" }}>
											Detalle
										</TableCell>
										<TableCell
											align="center"
											sx={{ fontWeight: "bold", backgroundColor: 'var(--theme-company)', color: "#fff" }}>
											Precio U.
										</TableCell>
										<TableCell
											align="center"
											sx={{ fontWeight: "bold", backgroundColor: 'var(--theme-company)', color: "#fff" }}>
											Descuento
										</TableCell>
										<TableCell
											align="center"
											sx={{ fontWeight: "bold", backgroundColor: 'var(--theme-company)', color: "#fff" }}>
											Total
										</TableCell>
										<TableCell
											align="center"
											sx={{ fontWeight: "bold", backgroundColor: 'var(--theme-company)', color: "#fff" }}>
											Cantidad
										</TableCell>
										<TableCell
											align="center"
											sx={{ fontWeight: "bold", backgroundColor: 'var(--theme-company)', color: "#fff" }}>
											Eliminar
										</TableCell>
									</TableRow>
								</TableHead>

								{/* Cuerpo */}
								<TableBody>
									{addedProducts.map((producto, index) => {
										const precioFacturado =
											parseFloat(producto.precio) * ((index_toggle != 0 ? facturadoMonto : 0) / 100);
										const precioDescuento =
											clienteSeleccionado && clienteSeleccionado.user_disc == null
												? parseFloat(producto.descuento || 0)
												: parseFloat(producto.precio) * (Number(clienteSeleccionado.user_disc) / 100);
										const totalProducto = parseFloat(
											(parseFloat(producto.precio) + precioFacturado - precioDescuento) *
											Number(producto.cantidad)
										).toFixed(2);

										return (
											<TableRow key={producto.id}>
												<TableCell align="center">{producto.codigo}</TableCell>
												<TableCell align="center">{producto.nombre}</TableCell>
												<TableCell align="center">{convertPrice(producto.precio)} </TableCell>
												<TableCell align="center">
													{clienteSeleccionado && clienteSeleccionado.user_disc == null ? (
														<div
															style={{
																display: "flex",
																flexFlow: "row nowrap",
																justifyContent: "center",
																alignItems: "center",
																width: "100%",
																height: "100%",
															}}>
															<TextField
																type="number"
																size="small"
																value={producto.descuento}
																onChange={(e) => handleChangeDescuento(index, e.target.value)}
																sx={{
																	"width": "100px",
																	"mx": 1,
																	"& .MuiInputBase-input": {
																		textAlign: "center",
																	},
																}}
															/>
															<span>{currency}</span>
														</div>
													) : (
														clienteSeleccionado.user_disc + "%"
													)}
												</TableCell>
												<TableCell align="center">{convertPrice(totalProducto)}</TableCell>

												{/* Cantidad con botones +/- */}
												<TableCell align="center">
													<Box sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
														<Button
															variant="contained"
															color="primary"
															size="small"
															onClick={() => handleDecreaseQuantity(index)}
															sx={{ minWidth: "30px" }}>
															-
														</Button>

														<TextField
															type="number"
															size="small"
															value={producto.cantidad}
															onChange={(e) => handleChangeCantidad(index, e.target.value)}
															sx={{
																"width": "60px",
																"mx": 1,
																"& .MuiInputBase-input": {
																	textAlign: "center",
																},
															}}
														/>

														<Button
															variant="contained"
															color="primary"
															size="small"
															onClick={() => handleIncreaseQuantity(index)}
															sx={{ minWidth: "30px" }}>
															+
														</Button>
													</Box>
												</TableCell>

												{/* Eliminar */}
												<TableCell align="center">
													<Button
														variant="contained"
														size="small"
														onClick={() => handleRemoveProduct(index)}
														sx={{
															"backgroundColor": "red",
															"color": "#fff",
															"padding": 0,
															"width": "30px",
															"minWidth": "30px",
															"height": "30px",
															"&:hover": {
																backgroundColor: "#c60000",
															},
														}}>
														<FontAwesomeIcon
															icon={faTrash}
															style={{ color: "#fff", fontSize: "15px" }}
														/>
													</Button>
												</TableCell>
											</TableRow>
										);
									})}
								</TableBody>

								{/* Pie de tabla */}
								<TableFooter>
									{totalDescuento > 0 ? (
										<TableRow>
											<TableCell colSpan={3} />
											<TableCell align="left" sx={{ fontWeight: "bold" }}>
												Total Descuento
											</TableCell>
											<TableCell align="center" sx={{ fontWeight: "bold" }}>
												{convertPrice(totalDescuento)}
											</TableCell>
											<TableCell />
											<TableCell />
										</TableRow>
									) : null}

									{/* Fila de Facturado (solo visible si isFacturado === true) */}
									{index_toggle > 0 ? (
										<TableRow>
											<TableCell colSpan={3} />

											<TableCell align="left" sx={{ fontWeight: "bold" }}>
												Total Facturado {delivery > 0 ? "+ Delivery" : ""}
											</TableCell>

											<TableCell align="center" sx={{ fontWeight: "bold" }}>
												{convertPrice((
													(addedProducts &&
														addedProducts.reduce((acc, item) => {
															const newPrice =
																(parseFloat(item.precio) +
																	(facturadoMonto / 100) * parseFloat(item.precio)) *
																item.cantidad;
															// const  acc + (parseFloat(item.precio) * item.cantidad), 0
															return acc + parseFloat(newPrice);
														}, 0)) +
													delivery -
													totalDescuento
												).toFixed(2))}
											</TableCell>

											<TableCell />
											<TableCell />
										</TableRow>
									) : null}

									{index_toggle != 2 ? (
										<TableRow>
											<TableCell colSpan={3} />

											<TableCell align="left" sx={{ fontWeight: "bold" }}>
												Total Sin Facturar {delivery > 0 ? "+ Delivery" : ""}
											</TableCell>

											<TableCell align="center" sx={{ fontWeight: "bold" }}>
												{convertPrice((
													(addedProducts &&
														addedProducts.reduce(
															(acc, item) => acc + parseFloat(item.precio) * item.cantidad,
															0
														)) +
													delivery -
													totalDescuento
												).toFixed(2))}
											</TableCell>

											<TableCell />
											<TableCell />
										</TableRow>
									) : null}
								</TableFooter>
							</Table>
						</TableContainer>
					</div>
				) : (
					<TableMobile
						style={{ marginTop: '10px' }}
						itsCompany={true}
						loadImageS={loadImageS}
						filteredData={(addedProducts ?? []).map(obj => ({
							img: obj?.img_product,
							title: obj?.nombre,
							texto: obj?.jobTitle,
							fullPhone: obj?.codePhone + obj?.phone,
							authCode: obj,
							code: obj?.codigo,
							cantidad: obj?.cantidad,
							total: calcular_total(obj)
						}))}
						profile={true}
						type={'profile'}
						functionEspecial={buttonDetailSaleMobile}
						mode="venta"
						returnTotal={returnTotalOperation}
						facturado={index_toggle}
					/>
				)
			}

			<GeneratePdfCotizacion isOpen={pdfModalVisible} themeColor={'var(--theme-company)'} apiResponse={pdfApiResponse} onClose={onPdfModalClose} convertPrice={convertPrice} />
			<ModalNuevoCliente
				isOpen={isModalOpenCliente}
				onClose={handleCloseModalCliente}
				keyBranch={selectedSucursal}
			/>
		</div>
	);
};
